import React from 'react';

interface AuthSelectScreenProps {
  onLogin: () => void;
  onSignup: () => void;
}

export const AuthSelectScreen: React.FC<AuthSelectScreenProps> = ({ onLogin, onSignup }) => {
  return (
    <div className="pwa-auth-container">
      <h1 className="pwa-auth-title">NEON GRID</h1>
      <p className="pwa-auth-subtitle">Direct player portal gateway</p>

      <button onClick={onLogin} className="pwa-primary-btn">
        SIGN IN
      </button>

      <button onClick={onSignup} className="pwa-secondary-btn">
        REGISTER
      </button>
    </div>
  );
};
